// Confetti canvas animation
// https://codepen.io/linrock/pen/Amdhr
// Usage: confettiWidget(<wrappername>);
export const confettiWidget = wrapperID => {
  let Confetti,
    canvas,
    confetti,
    context,
    drawCircle,
    i,
    range,
    resizeWindow,
    wrapper,
    xpos;

  const NUM_CONFETTI = 50;
  const COLORS = [
    [85, 71, 106],
    [174, 61, 99],
    [219, 56, 83],
    [244, 92, 68],
    [248, 182, 70],
  ];
  const PI_2 = 2 * Math.PI;

  let wrapID = typeof wrapperID !== 'undefined' ? wrapperID : 'confetti-widget';
  wrapper = document.getElementById(wrapID);

  if (!wrapper) {
    return;
  }

  canvas = document.createElement('canvas');
  canvas.className = 'confetti-canvas';
  wrapper.appendChild(canvas);
  wrapper.className = 'confetti-widget';
  context = canvas.getContext('2d');

  // ------------------------------------------
  // Window events
  window.w = 0;
  window.h = 0;

  resizeWindow = function() {
    if (typeof wrapper !== undefined) {
      window.w = canvas.width = wrapper.offsetWidth;
      return (window.h = canvas.height = wrapper.offsetHeight);
    }
  };

  window.addEventListener('resize', resizeWindow, false);

  // ------------------------------------------
  // Util
  range = function(a, b) {
    return (b - a) * Math.random() + a;
  };

  drawCircle = function(x, y, r, style) {
    context.beginPath();
    context.arc(x, y, r, 0, PI_2, false);
    context.fillStyle = style;
    return context.fill();
  };

  xpos = 0.5;

  // document.onmousemove = function(e) {
  //   return xpos = e.pageX / w;
  // };

  // ------------------------------------------
  // Animation frame
  window.requestAnimationFrame = (function() {
    return (
      window.requestAnimationFrame ||
      window.webkitRequestAnimationFrame ||
      window.mozRequestAnimationFrame ||
      window.oRequestAnimationFrame ||
      window.msRequestAnimationFrame ||
      function(callback) {
        return window.setTimeout(callback, 1000 / 60);
      }
    );
  })();

  // ------------------------------------------
  // Confetti
  Confetti = (function() {
    function Confetti() {
      this.style = COLORS[~~range(0, 5)];
      this.rgb =
        'rgba(' + this.style[0] + ',' + this.style[1] + ',' + this.style[2];
      this.r = ~~range(2, 6);
      this.r2 = 2 * this.r;
      this.replace();
    }

    Confetti.prototype.replace = function() {
      this.opacity = 0;
      this.dop = 0.03 * range(1, 4);
      this.x = range(-this.r2, w - this.r2);
      this.y = range(-20, h - this.r2);
      this.xmax = w - this.r;
      this.ymax = h - this.r;
      this.vx = range(0, 2) + 8 * xpos - 5;
      return (this.vy = 0.7 * this.r + range(-1, 1));
    };

    Confetti.prototype.draw = function() {
      var ref;
      this.x += this.vx;
      this.y += this.vy;
      this.opacity += this.dop;
      if (this.opacity > 1) {
        this.opacity = 1;
        this.dop *= -1;
      }
      if (this.opacity < 0 || this.y > this.ymax) {
        this.replace();
      }
      if (!(0 < (ref = this.x) && ref < this.xmax)) {
        this.x = (this.x + this.xmax) % this.xmax;
      }
      return drawCircle(
        ~~this.x,
        ~~this.y,
        this.r,
        this.rgb + ',' + this.opacity + ')'
      );
    };

    return Confetti;
  })();

  confetti = (function() {
    var j, ref, results;
    results = [];
    for (
      i = j = 1, ref = NUM_CONFETTI;
      1 <= ref ? j <= ref : j >= ref;
      i = 1 <= ref ? ++j : --j
    ) {
      results.push(new Confetti());
    }
    return results;
  })();

  // ------------------------------------------
  // Canvas animation step
  let step = function() {
    var c, j, len, results;
    requestAnimationFrame(step);
    context.clearRect(0, 0, w, h);
    results = [];
    for (j = 0, len = confetti.length; j < len; j++) {
      c = confetti[j];
      results.push(c.draw());
    }
    return results;
  };

  step();

  return {
    startAnimation: function() {
      return setTimeout(resizeWindow, 1000);
    },

    cancelAnimation: function() {
      window.cancelRequestAnimFrame = (function() {
        return (
          window.cancelAnimationFrame ||
          window.webkitCancelRequestAnimationFrame ||
          window.mozCancelRequestAnimationFrame ||
          window.oCancelRequestAnimationFrame ||
          window.msCancelRequestAnimationFrame ||
          clearTimeout
        );
      })();

      for (var i = 1; i < 99999; i++) {
        window.cancelRequestAnimFrame(i);
      }
    },
  };
};



// WEBPACK FOOTER //
// ./src/utils/confettiWidget.js